import React from 'react';

import * as S from './NotFoundPopupStyle';

const NotFoundPopupUI = (props) => {
    const {headerDate,currentDate,onClickCB} = props;
    return (
        <S.NotFoundPopup>
            <p className="notFoundPopupHeading">{`Showing buses for ${headerDate}`}</p>
            <p>{`We could not find any buses for your route for ${currentDate}.`}</p>
            <p>{`We are showing you buses for the next day, ${headerDate} for your route.`}</p>
            <div onClick={onClickCB}>GOT IT</div>
        </S.NotFoundPopup>
    );
};

export default NotFoundPopupUI;

